module.exports = "/assets/success-picture.png?1lCbFFx";